import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth/auth.service';
import { FileDTO } from 'projects/qcloud-models/fileManager/file-dto.model';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  appBase: string;

  public setAppBase(appBase: string){
    this.appBase = appBase;
  }

  public getUploadAddress() {
    return `${this.appBase}api/${this.authService.getSystemId()}/${this.authService.getLocationId()}/files/upload`;
  }

  constructor(private http: HttpClient, private authService: AuthService) { }

  getDirectoryContent(path: string) : Observable<FileDTO[]> {
    return this.http.post<FileDTO[]>(`${this.appBase}api/${this.authService.getSystemId()}/${this.authService.getLocationId()}/files`, {path: path});
  }

  createFolder(path: string, folderName: string) {
    return this.http.post(`${this.appBase}api/${this.authService.getSystemId()}/${this.authService.getLocationId()}/files/create`,
      {name: folderName, path: path});
  }

  deleteSelected(list: FileDTO[]) {
    return this.http.post(`${this.appBase}api/${this.authService.getSystemId()}/${this.authService.getLocationId()}/files/delete`, list);
  };

  getPathToImage(filePath: string, fileName?: string) {
    if (fileName) {
      let thumbnail = "__" + fileName; 
      filePath = filePath.replace(fileName, thumbnail);
      if (this.isVideo(filePath)) {
        filePath = filePath.replace(this.getExtension(filePath), '.png');
      }
    }
    return `${this.appBase}cdn/${this.authService.getSystemId()}/${this.authService.getLocationId()}${filePath}`;
  }

  getExtension(filePath: string): string {
    return filePath.substring(filePath.lastIndexOf('.'), filePath.length);
  }

  isImage(filePath: string): boolean {
    if (filePath) {
      let extension = this.getExtension(filePath);
      switch (extension.toLowerCase()) {
        case '.jpg':
        case '.gif':
        case '.bmp':
        case '.png':
        case '.webp':
        case '.gif':
          return true;
      }
    }
    return false;
  }
  
  isVideo(filePath: string): boolean {
    if (filePath) {
      let extension = this.getExtension(filePath);
      switch (extension.toLowerCase()) {
        case '.m4v':
        case '.avi':
        case '.mpg':
        case '.mp4':
          return true;
      }
    }
    return false;
  }

  isUrl(name: string): boolean {
    return ".https" == this.getExtension(name) || ".http" == this.getExtension(name);
  }

  isFail(name: string): boolean {
    return ".fail" == this.getExtension(name);
  }

  isProgress(name: string): boolean {
    return ".inprogress" == this.getExtension(name);
  }

  checkImageStatus(url: string) {
    return this.http.get(url);
  }

  getUrlForDevice(path: string) {
    return "url(\"" + this.appBase + `cdn/${this.authService.getSystemId()}/${this.authService.getLocationId()}/` + this.removeDoubleSlashInFront(path) + "\")";
  }

  private removeDoubleSlashInFront(name: string): string {
    return name.substring(1);
  }
}
